<template>
<div id="secure">
    
    <NewTopMenu />
    <b-message title="How to start?" type="is-success" aria-close-label="Close message" class="notification-tutorial">
        <ul>
            <li>First, add your school logo from Home > Profile > Account > upload logo.</li>
            <li>How to add teachers?  From Home, Go to Edit Database section > Create a class/department > Add teachers/supervisor > Add or upload teachers/supervisor.</li>
            <li>How to add students? From home, go to Edit Database > Class/Departments > Choose class, Manage > Add students/upload excel file</li>
            <li>Next, add behavior items. Go to Edit Behavior/Kpi > Add a behavior.</li>
        </ul>
    </b-message>
    <b-message title="Tips" type="is-info" aria-close-label="Close message" class="notification-tutorial">
        Create attendance system for teachers by creating  a class name "Teachers" and add list of teachers inside it. Make the teachers as students inside that class.
    </b-message>
    <div class="container">
        <div class="columns is-gapless" style="margin-top: 20px;">
            <div class="column cursor-pointer" v-on:click="goAttendance()">
                <img src="@/assets/img/1.png" />
            </div>
            <div class="column cursor-pointer" v-on:click="goLeaderboard()">
                <img src="@/assets/img/3.png" />
            </div>
            <div class="column cursor-pointer" v-on:click="goECertificate()">
                <img src="@/assets/img/4.png" />
            </div>
        </div>

        <div class="columns is-gapless" style="margin-top: -20px;" v-show="userType == 1">
            <div class="column cursor-pointer" v-on:click="goManageClasses()">
                <img src="@/assets/img/5.png" />
            </div>
            <div class="column cursor-pointer" v-on:click="goManageBehaviors()">
                <img src="@/assets/img/6.png" />
            </div>
            <div class="column cursor-pointer" v-on:click="goManageNotifications()">
                <img src="@/assets/img/8.png" />
            </div>
        </div>

        <div class="columns is-gapless" style="margin-top: -30px;" v-show="userType == 1">
            <!-- <div class="column cursor-pointer" v-on:click="clickTopRightButton()">
                <img src="@/assets/img/request_monthly_report.png" />
            </div> -->
            <div class="column is-6">&nbsp;</div>
            <div class="column is-3 cursor-pointer" v-on:click="goUnrevokeSubmissions()">
                <img src="@/assets/img/retrieve_revoked_submission.png" />
            </div>
            <div class="column is-3 cursor-pointer" v-on:click="goManageForms()">
                <img src="@/assets/img/create_eform.png" />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
const helper = require("../../config/helper")

export default {
    name: "Home",
    components: {
        NewTopMenu
    },
    data() {
        return {
            userType : 1,
        };
    },
    created() {
        this.userType = localStorage.getItem('userType')
        console.log("81 this.userType: " + this.userType)
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    mounted() {},
    methods: {
        goAttendance() {
            this.$router.push({
                name: "Attendance"
            });
        },
        goOverallAnalysis() {
            this.$router.push({
                name: "OverallAnalysis"
            });
        },
        goLeaderboard() {
            this.$router.push({
                name: "Leaderboard"
            });
        },
        goManageForms() {
            this.$router.push({
                name: "ManageFormsHome"
            });
        },
        goManageClasses() {
            this.$router.push({
                name: "ManageClassesHome"
            });
        },
        goManageBehaviors(){
            this.$router.push({
                name: "ManageBehaviorsHome"
            });
        },
        goManageNotifications(){
            this.$router.push({
                name: "ManageNotificationsHome"
            });
        },
        goUnrevokeSubmissions() {
            this.$router.push({
                name: "UnRevoke"
            });
        },
        goSetup() {
            this.$router.push({
                name: "Setup"
            });
        },
        goECertificate(){
            window.open("https://certificate.studentqr.com/", '_blank');
        },
    }
};
</script>

<style scoped>
body{
    background-color: #F2F4F8;
}
.big-button{
    text-align: center;
    height: 150px;
    display: flex;           /* establish flex container */
    flex-direction: column;  /* make main axis vertical */
    justify-content: center; /* center items vertically, in this case */
    align-items: center;     /* center items horizontally, in this case */
    cursor: pointer;
}
.cursor-pointer{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue